export const updateLatestMessageInChats = (chats, message) => {
  return chats.map((chat) =>
    chat._id === message.chat._id ? { ...chat, latestMessage: message } : chat
  );
};

export const reorderChats = (chats, message) => {
  const updated = chats.map((chat) =>
    chat._id === message.chat._id ? { ...chat, latestMessage: message } : chat
  );
  const topChat = updated.find((chat) => chat._id === message.chat._id);
  const otherChats = updated.filter((chat) => chat._id !== message.chat._id);
  return [topChat, ...otherChats];
};
